import { MouseEventHandler } from 'react';

import { useTranslation } from 'libs/i18n';
import { Icon } from 'libs/ui/Icon';

import { Tooltip } from '../Tooltip';

import { ContentStyled } from './CopyButton.styles';

export interface CopyButtonProps {
  value?: any;
  /**
   * If `true`, the button will be interactive (hover, active, etc.).
   * @default false
   */
  interactive?: boolean;
}

export const CopyButton = ({ value, interactive }: CopyButtonProps) => {
  const { t } = useTranslation();

  const copy: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Copy the text inside the text field
    navigator.clipboard.writeText(value);
  };
  if (!value) return null;

  return (
    <Tooltip title={t('common.copy')}>
      <ContentStyled interactive={interactive} onClick={copy}>
        <Icon.Copy className="copyButton-icon" />
      </ContentStyled>
    </Tooltip>
  );
};
